import React, {Component} from 'react';
import { Button, Row, Col, Form, Container } from "reactstrap";
import {inject, observer} from "mobx-react/index";
import Card from '../../../comum/components/Card';
import InputFiltro from '../../../comum/components/InputFiltro';
import SelectFiltro from '../../../comum/components/SelectFiltro';
import {montarSelectionBooking} from '../../../../utils/formatar'
import lscache from 'lscache'


@inject("store")
@observer
export default class FiltrosBooking extends Component {
    constructor(props) {
        super(props);
        {/* TODO: inserir proptypes */}

        this.filtrar = this.filtrar.bind(this)
        this.controller = this.props.controller;
    }

    filtrar(e){
        e.preventDefault()
        this.controller.carregarLista()
    }

    render() {

        let camposXl = 3;

        {/* TODO : melhorar no mobile */ }
        return(
            <Container fluid>
                <Card className="tabela-container area-form pb-0">
                    <div className="filtros">
                        <Form onSubmit={this.filtrar}>
                            <Row className="align-items-end bg-danger">
                                <InputFiltro className="mb-1" titulo="Cód. Booking" xl={camposXl} sm={6} xs={12}
                                    uppercase={true}
                                    onChange={(event) => this.props.buscarPorCodigo(event.target.value)} />

                                {lscache.get('Perfil').includes('ARMADOR') && <SelectFiltro titulo="Operação" xl={camposXl} sm={6} xs={12}
                                    itens={this.props.operacoes}
                                    valor={(this.props.codigoBooking) ? this.props.codigoBooking: this.props.operacoesSelecionado}
                                    itensValor="Viagem" itensLabel="NavioNome"
                                    onChange={this.props.selecionarOperacao}
                                    options={montarSelectionBooking('Viagem',this.props.operacoes)}
                                
                                />}
                                
                                <Col xl={camposXl} sm={6} xs={12} className="mb-1 justify-content-start align-bottom">
                                    <Button className="btn-com-bordas-primary btn-filtrar">Filtrar</Button>
                                </Col>
                            </Row>

                        </Form>
                    </div>
                </Card>
            </Container>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/consultas/booking/components/FiltrosBooking.js